import { Button } from "@mui/material";

import AlertConfirm from "commons/ui/alert/AlertConfirm";
import DataTableSimple from "commons/ui/datatable/DataTableSimple";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import DocumentTableFilters from "components/subComponents/DocumentTableFilters";

import useDocumentsList from "hooks/list/useDocumentsList";

function ElencoDocumenti() {
    const documentsListHook = useDocumentsList();

    const { navigateToNewDocument, alertConfirmHook, dataTableHook } = documentsListHook;

    return (
        <GridColumn>
            <AlertConfirm alertConfirmHook={alertConfirmHook} />

            <Paper className={"table-with-filters"}>
                <DocumentTableFilters documentsListHook={documentsListHook} />

                <DataTableSimple dataTableHook={dataTableHook} dontUsePaper />
            </Paper>

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={navigateToNewDocument}>
                        Nuovo documento
                    </Button>
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default ElencoDocumenti;
